/**
 * The page-actions slot: where a screen puts its page-level commands (New
 * case, Export CSV…) so they sit in the title row beside the shell's `<h1>`
 * rather than under a second heading of their own.
 *
 * A `.ts` module with no component in it, for the reason `shellState.ts`
 * gives: a module that exports a component may export nothing else.
 */

import { createContext } from 'react';

/** The element `PageActions` portals into, or null outside the shell / before it mounts. */
export const PageActionsContext = createContext<HTMLElement | null>(null);

/** True inside the shell, where the slot exists; false in isolation (unit tests, harnesses). */
export const InShellContext = createContext(false);
